import React from 'react'
import './Shucks.sass'

const Shucks = ({children, native}) => <span className={`Shucks ${native ? 'native': ''}`}><span className='shuck-symbol'>$</span> {children}</span>
export default Shucks

export const sanitiseMoney = (amount) => (
  Math.abs(parseFloat(amount))
)